export default {
    english: 'EN_CA',
    french: 'FR_CA',
    failedTwoMany: 'FAILED_TOO_MANY_INSPECTIONS',
    chargeBackFraud: 'CHARGEBACK_FRAUD',
    backOfficeOverride: 'BACK_OFFICE_OVERRIDE',
    setDefaultTrip: 'DEFAULT_TRIP_SET',
    removeDefaultTrip: 'DEFAULT_TRIP_REMOVE',
}